'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.788 21.325c.407 0 .73-.177.967-.53L21.152 4.492c.085-.146.146-.276.184-.391.039-.116.058-.227.058-.334a.888.888 0 0 0-.253-.657c-.161-.168-.376-.253-.645-.253a.877.877 0 0 0-.472.115 1.307 1.307 0 0 0-.369.392L9.742 19.09l-5.1-6.551c-.23-.322-.51-.483-.84-.483a.92.92 0 0 0-.68.264.867.867 0 0 0-.265.657c0 .122.023.245.07.368.053.115.126.234.218.357l5.619 7.07c.291.368.633.552 1.024.552Z",
    fill: "#000"
  })));
};

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.795 21.167c0-.622-.452-1.095-1.075-1.095H12.1c.272-.03.533-.15.734-.361l6.61-6.62c.24-.24.35-.512.35-.813 0-.623-.461-1.085-1.074-1.085-.311 0-.593.13-.794.332l-2.29 2.26-2.601 2.913.08-2.17V2.123c0-.673-.452-1.135-1.115-1.135s-1.115.462-1.115 1.135v12.405l.08 2.16-2.601-2.903-2.29-2.26a1.13 1.13 0 0 0-.804-.332c-.613 0-1.065.462-1.065 1.085 0 .301.11.572.352.813l6.61 6.62c.2.21.461.331.733.362H5.3c-.633 0-1.095.472-1.095 1.094 0 .623.462 1.095 1.095 1.095h13.42c.623 0 1.075-.472 1.075-1.095Z",
    fill: "#1C1C1E"
  })));
};

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.99 21.991c5.695 0 10.396-4.7 10.396-10.386 0-5.685-4.71-10.386-10.406-10.386-5.685 0-10.376 4.7-10.376 10.386 0 5.685 4.7 10.386 10.386 10.386Zm0-2.07a8.278 8.278 0 0 1-8.297-8.316 8.267 8.267 0 0 1 8.287-8.307 8.301 8.301 0 0 1 8.327 8.307 8.289 8.289 0 0 1-8.317 8.317Zm-.01-6.649c.552 0 .874-.311.884-.894l.15-4.831c.02-.593-.421-1.025-1.044-1.025s-1.055.422-1.035 1.015l.14 4.841c.021.573.342.894.905.894Zm0 3.335c.653 0 1.185-.472 1.185-1.115 0-.633-.522-1.105-1.185-1.105-.653 0-1.185.472-1.185 1.105s.542 1.115 1.185 1.115Z",
    fill: "#1C1C1E"
  })));
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.99 21.991c5.695 0 10.396-4.7 10.396-10.386 0-5.685-4.71-10.386-10.406-10.386-5.685 0-10.376 4.7-10.376 10.386 0 5.685 4.7 10.386 10.386 10.386Zm0-2.07a8.278 8.278 0 0 1-8.297-8.316 8.267 8.267 0 0 1 8.287-8.307 8.301 8.301 0 0 1 8.327 8.307 8.289 8.289 0 0 1-8.317 8.317ZM8.183 12.57h7.604c.603 0 1.034-.351 1.034-.934 0-.593-.411-.954-1.034-.954H8.183c-.613 0-1.035.361-1.035.954 0 .583.432.934 1.035.934Z",
    fill: "#1C1C1E"
  })));
};

exports.SvgCheck = SvgCheck;
exports.SvgDownload = SvgDownload;
exports.SvgExclamationMark = SvgExclamationMark;
exports.SvgMinusCircle = SvgMinusCircle;
